import {
  axiosErrorHandler,
  EnumModalWinner,
  onceSessionUtil,
  TEXTS,
  URLs,
} from '@/utils';
import axiosGdt from '@/utils/axiosGdt';

export type ResponseDB = {
  estado: boolean;
  razonesPedirDB: {
    idRazon: number;
  }[];
  tieneDB: boolean;
};

const NO_REQUEST: ResponseDB = {
  estado: false,
  razonesPedirDB: [],
  tieneDB: false,
};

// NO APLICA GUARDAR DATO CBU FORMULARIO
// export const guardarDB = axiosErrorHandler(async (params: any) => {
//   const url = URLs.GANADOR_GUARDAR_CBU;
//   const response = await axiosGdt.post(url, {
//     params,
//   });
//   return response.data;
// }, TEXTS.defaultError);

// export function obtenerDB() {
//   const url = GURL.MCDB_OBTENER_CBU;
//   return $.api2(url, true).then(function (theData) {
//     console.log(theData);
//     return theData;
//   });
// }

export const requestDB = axiosErrorHandler(async (idsRazones: number[]) => {
  const params = new URLSearchParams({
    razones: idsRazones.join(','),
  });
  const url = `${URLs.MI_CUENTA.GANADOR_DEBO_PEDIR_CBU}`;

  const response = await axiosGdt.get<ResponseDB>(url, { params });
  return response.data;
}, TEXTS.defaultError);

export const requestF5DB = (passId: string): Promise<ResponseDB> => {
  if (onceSessionUtil.setPreviouslyChecked('db_popf5_check', passId)) {
    return Promise.resolve(NO_REQUEST);
  }
  const idsRazones = [
    EnumModalWinner.FUTBOL5.id,
    EnumModalWinner.FUTBOL5_GRAL.id,
  ];
  return anularSiYaPidioEnSesion(
    requestDB(idsRazones),
    'db_popf5_shown',
    passId
  );
};

export const requestTdaDB = (passId: string): Promise<ResponseDB> => {
  if (onceSessionUtil.setPreviouslyChecked('db_popTdaPremium_check', passId)) {
    return Promise.resolve(NO_REQUEST);
  }
  const idsRazones = [EnumModalWinner.TDA_PREMIUM.id];
  return anularSiYaPidioEnSesion(
    requestDB(idsRazones),
    'db_popTdaPremium_shown',
    passId
  );
};

export const requestPremiumDateDB = (passId: string): Promise<ResponseDB> => {
  if (onceSessionUtil.setPreviouslyChecked('db_fpremium_check', passId)) {
    return Promise.resolve(NO_REQUEST);
  }
  const idsRazones = [EnumModalWinner.FECHA_PREMIUM.id];
  return anularSiYaPidioEnSesion(
    requestDB(idsRazones),
    'db_popfpremium_show',
    passId
  );
};

export const anularSiYaPidioEnSesion = async (
  request: Promise<Promise<ResponseDB>>,
  cacheKey: string | number,
  passId: string
) => {
  const response = await request;
  return request.then((data) => {
    // se va a rar
    if (!response.tieneDB && response.razonesPedirDB?.length > 0) {
      if (onceSessionUtil.setPreviouslyShown(String(cacheKey), passId)) {
        return NO_REQUEST;
      }
    }
    return data;
  });
};
